/* eslint-disable react/prop-types */
import React from 'react';
import Reducer from './reducer';

const initialState = {
  // State
  overlay: null,
  activeAccount: null,
  switchingAccount: false,
  userIsAdmin: false,
  // Refs
  navRef: null,
  menuRef: null,
  navToggleRef: null,
  menuToggleRef: null
};

export const Context = React.createContext(initialState);

const Store = ({ children }) => {
  const [state, dispatch] = React.useReducer(Reducer, initialState);
  // eslint-disable-next-line react/jsx-no-constructed-context-values
  return <Context.Provider value={[state, dispatch]}>{children}</Context.Provider>;
};

export default Store;
